// The three stages of the workforce-planning wizard — set demand for a
// growing role, review its candidates, then the cross-role summary.
export const WORKFORCE_PLANNING_STEP = Object.freeze({
  DEMAND: "demand",
  CANDIDATES: "candidates",
  SUMMARY: "summary",
});

export const WORKFORCE_PLANNING_STEPS = [
  { key: WORKFORCE_PLANNING_STEP.DEMAND, label: "1 · Demand" },
  { key: WORKFORCE_PLANNING_STEP.CANDIDATES, label: "2 · Candidates" },
  { key: WORKFORCE_PLANNING_STEP.SUMMARY, label: "3 · Summary" },
];

export const WORKFORCE_PLAN_CSV_FILENAME = "workforce-planning-summary";
